import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { withNamespaces } from 'react-i18next'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Button from '@material-ui/core/Button'
import { faFilter } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import i18next from 'i18next'
import Drawer from '@material-ui/core/Drawer'
import List from '@material-ui/core/List'
import Divider from '@material-ui/core/Divider'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch'
import * as HRRequestType from '@scripts/HRRequestType'
import * as HRRequestStatusCode from '@scripts/HRRequestStatusCode'
import * as storage from '@utils/storage'
import PropTypes from 'prop-types'
import styles from '@styles/request.module.css'

const useStyles = makeStyles(theme => ({
    toolBar: {
        alignSelf: 'flex-end',
        color: "var(--color1) !important"
    },
    buttonFilter: {
        marginTop: '10px',
        border: '1px solid red'
    },
    appBar: {
        boxShadow: 'none !important'
    }
}));

function HRRequestFilter(props) {
    const classes = useStyles();

    const [open, setOpen] = React.useState(false);
    const [listFilter, setListFilter] = React.useState([]);
    const [requestType, setRequestType] = React.useState({
        documentDeposit: true
    });

    const [status, setStatus] = React.useState({
        approved: false,
        canceled: false,
        infoRequired: true,
        infoReturned: false,
        newRequest: true,
        processing: true,
        waiting: true
    });

    const [requestTypeValue, setRequestTypeValue] = React.useState(null);
    const [statusValue, setStatusValue] = React.useState(null);

    const [isFirst, setIsFirst] = React.useState(false);

    const { handleFilter } = props;

    useEffect(() => {
        loadPage();
    }, [])

    useEffect(() => {
        handleRequestTypeValue();
    }, [requestType])

    useEffect(() => {
        handleStatusValue();
    }, [status])

    useEffect(() => {
        // Workaround to pass the right parameters after the changing status on the page load

        if (isFirst) {
            handleFilter([requestTypeValue, statusValue]);
        }
    }, [isFirst])

    const loadPage = async () => {
        await loadFilter();
        await handleStorageFilter();
        setIsFirst(true);
    }

    const loadFilter = async () => {
        return new Promise(resolve => {
            var list = [
                {
                    typeFilter: i18next.t("hrRequest:filter.requestType"),
                    key: "requestType",
                    items: [
                        {
                            description: "DocumentDeposit",
                            key: "documentDeposit",
                            value: HRRequestType.Type_DocumentDeposit
                        }
                    ]
                },
                {
                    typeFilter: i18next.t("hrRequest:filter.status"),
                    key: "hrRequestStatus",
                    items: [
                        {
                            key: "approved",
                            value: HRRequestStatusCode.Approved
                        },
                        {
                            key: "canceled",
                            value: HRRequestStatusCode.Canceled
                        },
                        {
                            key: "infoRequired",
                            value: HRRequestStatusCode.InfoRequired
                        },
                        {
                            key: "infoReturned",
                            value: HRRequestStatusCode.InfoReturned
                        },
                        {
                            key: "newRequest",
                            value: HRRequestStatusCode.NewRequest
                        },
                        {
                            key: "processing",
                            value: HRRequestStatusCode.Processing
                        },
                        {
                            key: "waiting",
                            value: HRRequestStatusCode.Waiting
                        }
                    ]
                }
            ];
            setListFilter(list);
            resolve();
        })
    }

    const handleStorageFilter = () => {
        return new Promise(resolve => {
            const filter = storage.getHrRequestFilter();

            if (filter !== undefined) {
                setRequestType(filter.requestType);
                setStatus(filter.status);
            }

            resolve();
        });
    }

    const handleOpenFilter = () => {
        setOpen(true);
    }

    const handleFilterSubmit = () => {
        handleFilter([requestTypeValue, statusValue]);
        handleSaveStorageFilter();
        setOpen(false);
    }

    const handleRequestTypeValue = () => {
        const arrayValue = [];

        if (requestType.documentDeposit) {
            arrayValue.push(HRRequestType.Type_DocumentDeposit);
        }

        setRequestTypeValue(arrayValue);
    }

    const handleStatusValue = () => {
        const arrayValue = [];

        if (status.approved) {
            arrayValue.push(HRRequestStatusCode.Approved);
        }
        if (status.canceled) {
            arrayValue.push(HRRequestStatusCode.Canceled);
        }
        if (status.infoRequired) {
            arrayValue.push(HRRequestStatusCode.InfoRequired);
        }
        if (status.infoReturned) {
            arrayValue.push(HRRequestStatusCode.InfoReturned);
        }
        if (status.newRequest) {
            arrayValue.push(HRRequestStatusCode.NewRequest);
        }
        if (status.processing) {
            arrayValue.push(HRRequestStatusCode.Processing);
        }
        if (status.waiting) {
            arrayValue.push(HRRequestStatusCode.Waiting);
        }

        setStatusValue(arrayValue);
    }

    const handleSaveStorageFilter = () => {
        const filter = {
            requestType: requestType,
            status: status
        }

        storage.saveHrRequestFilter(filter);
    }

    const toggleDrawer = (open) => (event) => {
        // This is to avoid the drawer to close when we click within the filter div
        const role = event.currentTarget.attributes.role;
        if (role !== undefined && role.value === 'filter') {
            return;
        }

        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setOpen(open);
    };

    const listChild = (items, type) => {
        return (
            items.map((element, index) => (
                <FormControl key={index} className={styles.itemsFilter}>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={(type === 'requestType' ? requestType[element.key] : status[element.key]) || false}
                                onChange={(event) => onChangeFilter(event, element.key, type)}
                                name={`filter-${element.key}`}
                                variant="success"
                            />
                        }
                        label={i18next.t(`hrRequest:${type === 'requestType' ? "requestType" : "status"}.${element.key}`)}
                        labelPlacement="end"
                    />
                </FormControl>
            )))
    }

    const list = (
        <div
            role="filter"
            onClick={toggleDrawer(false)}
            onKeyDown={toggleDrawer(false)}
        >
            {listFilter.map((obj, index) => (
                <React.Fragment key={index}>
                    <List>
                        <ListItem>
                            <ListItemText primary={obj.typeFilter} />
                        </ListItem>
                    </List>

                    {listChild(obj.items, obj.key)}
                    <Divider />
                </React.Fragment>
            ))}
        </div>
    );

    const onChangeFilter = (event, key, typeFilter) => {
        if (typeFilter === 'requestType') {
            setRequestType({
                ...requestType,
                [key]: event.target.checked
            });
        }
        else {
            setStatus({
                ...status,
                [key]: event.target.checked
            });
        }
    }

    return (
        <div id="divFilterRequest">
            <React.Fragment>
                <AppBar position="static" className={classes.appBar}>
                    <Toolbar className={classes.toolBar}>
                        <Button startIcon={<FontAwesomeIcon icon={faFilter} className="fa-w-16" />} color="inherit" onClick={handleOpenFilter}>{i18next.t('hrRequest:filter.button')}</Button>
                    </Toolbar>
                </AppBar>
                <Drawer anchor={'right'} open={open} onClose={toggleDrawer(false)}>

                    {list}
                    <Button className={styles.buttonFilter} startIcon={<FontAwesomeIcon icon={faFilter} className="fa-w-16" />} color="primary" onClick={handleFilterSubmit}>{i18next.t('hrRequest:filter.button')}</Button>
                </Drawer>
            </React.Fragment>
        </div>
    );
}

export default withNamespaces(['hrRequest'], { wait: true })(HRRequestFilter);

HRRequestFilter.propTypes = {
    handleFilter: PropTypes.func.isRequired
}